import type { RouteRecordRaw } from 'vue-router';

import { computed } from 'vue';

import { useGlobalI18n } from '@abaninja/util-i18n';

const {
  global: { t },
} = useGlobalI18n();

export const routes: RouteRecordRaw[] = [
  {
    path: 'documents',

    children: [
      {
        name: 'documents',
        path: '',
        component: () => import('../DocumentsIndex.vue'),

        meta: {
          title: computed(() => t('messages.documents')),
        },
      },
      {
        name: 'invoice',
        path: 'invoice/:uuid',
        props: true,
        component: () => import('../InvoiceIndex.vue'),
      },
      {
        name: 'quote',
        path: 'quote/:uuid',
        props: true,
        component: () => import('../QuoteIndex.vue'),
      },
      {
        name: 'contract-note',
        path: 'contract-note/:uuid',
        props: true,
        component: () => import('../ContractNoteIndex.vue'),
      },
      {
        name: 'credit-note',
        path: 'credit-note/:uuid',
        props: true,
        component: () => import('../CreditNoteIndex.vue'),
      },

      // fallback
      {
        name: 'document',
        path: 'document/:uuid',
        props: true,
        component: () => import('../DocumentIndex.vue'),
      },
    ],
  },
];
